module.exports = __webpack_public_path__ + "static/media/ellipsis-loading.06802f01.gif";